module.exports = __webpack_public_path__ + "img/nodata1.9f9da028.png";